export default __webpack_public_path__ + "static/media/image3pro3.edd57796.jpeg";